// UnsavedGuardDialog — globálny 3-tlačidlový dialóg neuložených zmien (ústava 53.1 / #5).
// Mount RAZ v Layout. Registruje sa do unsavedGuard singletonu; confirmLeave() ho zobrazí.
import React, { useState, useEffect, useRef } from 'react'
import { registerUnsavedDialog } from '../hooks/unsavedGuard.js'
import { COLORS, RADIUS, TYPO } from '../theme.js'

export default function UnsavedGuardDialog() {
  const [open, setOpen] = useState(false)
  const [canSave, setCanSave] = useState(true)   // straz_v1: formulár bez vlastného ukladania → bez tlačidla Uložiť
  const resolverRef = useRef(null)

  useEffect(() => {
    registerUnsavedDialog((info) => new Promise(res => { resolverRef.current = res; setCanSave(!info || info.canSave !== false); setOpen(true) }))
    return () => registerUnsavedDialog(null)
  }, [])

  const choose = (c) => {
    setOpen(false)
    const r = resolverRef.current; resolverRef.current = null
    if (r) r(c)
  }

  // Esc = Zrušiť (zostať)
  useEffect(() => {
    if (!open) return
    const onKey = (e) => { if (e.key === 'Escape') choose('cancel') }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [open])

  if (!open) return null
  const btn = (bg, color, border) => ({
    padding: '9px 16px', borderRadius: RADIUS.md, fontSize: TYPO.sizes.sm, fontWeight: TYPO.weights.bold,
    cursor: 'pointer', fontFamily: 'inherit', background: bg, color, border: border || 'none',
  })
  return (
    <div onClick={() => choose('cancel')} style={{
      position: 'fixed', inset: 0, zIndex: 100000, background: 'rgba(15,20,30,0.45)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20,
    }}>
      <div onClick={e => e.stopPropagation()} style={{
        background: '#fff', borderRadius: 14, padding: '22px 24px', maxWidth: 460, width: '100%',
        boxShadow: '0 14px 44px rgba(0,0,0,0.32)', borderTop: `4px solid ${COLORS.warn}`,
      }}>
        <div style={{ fontSize: 18, fontWeight: TYPO.weights.extra, color: COLORS.text, marginBottom: 8 }}>Neuložené zmeny</div>
        <div style={{ fontSize: 14, color: COLORS.muted, lineHeight: 1.5, marginBottom: 22 }}>
          {canSave ? 'Máš neuložené zmeny. Čo chceš spraviť pred odchodom?' : 'Máš neuložené zmeny. Ulož ich tlačidlom Uložiť na obrazovke, alebo ich zahoď.'}
        </div>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
          <button onClick={() => choose('cancel')} style={btn('#fff', COLORS.muted, `1px solid ${COLORS.line}`)}>Zrušiť</button>
          <button onClick={() => choose('discard')} style={btn('#fff', COLORS.remove, `1px solid ${COLORS.remove}`)}>Zahodiť zmeny</button>
          {canSave && <button onClick={() => choose('save')} style={btn(COLORS.add, '#fff')}>Uložiť</button>}
        </div>
      </div>
    </div>
  )
}
